import axiosInstance from "../http/axios_instance"
const http = axiosInstance("/protected/orgadmin/",  null, "/dashboard")


const getOrganisation = () => http.get("/organisation");
const putOrgNotifications = (body) => http.put("/notifications", body)
const getOrgNotificationList = () => http.get("/notification_list")
const putOrgNotificationList = (body) => http.put("/notification_list", body)
const postOrgNotificationList = (body) => http.post("/notification_list", body)

export default {
    getOrganisation,
    putOrgNotifications,
    getOrgNotificationList,
    putOrgNotificationList,
    postOrgNotificationList
}